import { __decorate } from "tslib";
import { Vue, Component } from "vue-property-decorator";
import IconSvg from "@/components/IconSvg.vue";
let InfoSkills = class InfoSkills extends Vue {
    constructor() {
        super(...arguments);
        this.advItems = [
            "Эксклюзивные методики педагогов",
            "Маленькие группы до&nbsp;6&nbsp;человек, формируются по&nbsp;возрасту",
            "Результативность наших онлайн-занятий оценили 99%&nbsp;родителей",
        ];
    }
};
InfoSkills = __decorate([
    Component({
        components: {
            IconSvg,
        },
    })
], InfoSkills);
export default InfoSkills;
